export class ProductManagementSearchRequest {
  /*public static fromBeginRequest(): ProductManagementSearchRequest {
    return new ProductManagementSearchRequest();
  }*/

  private static readonly MaxTotalPerPages: number = 10;

  private startIndex: number;
  private totalPerPages: number;
  private filterText: string;
  private pendingProducts: boolean;
  private startAt: string;
  private endAt: string;

  constructor() {
    this.startIndex = 1;
    this.totalPerPages = ProductManagementSearchRequest.MaxTotalPerPages;
  }

  public getStartIndex(): number {
    return this.startIndex;
  }

  public setStartIndex(value: number): void {
    this.startIndex = value;
  }

  public getTotalPerPages(): number {
    return this.totalPerPages;
  }

  public setTotalPerPages(value: number): void {
    this.totalPerPages = value;
  }

  public getFilterText(): string {
    return this.filterText;
  }

  public setFilterText(value: string): void {
    this.filterText = value;
  }

  public getPendingProducts(): boolean {
    return this.pendingProducts;
  }

  public setPendingProducts(pendingProducts: boolean): void {
    this.pendingProducts = pendingProducts;
  }

  public getStartAt(): string {
    return this.startAt;
  }

  public setStartAt(startAt: string): void {
    this.startAt = startAt;
  }

  public getEndAt(): string {
    return this.endAt;
  }

  public setEndAt(endAt: string): void {
    this.endAt = endAt;
  }
}
